import { render, staticRenderFns } from "./indexCategoryItems(old).vue?vue&type=template&id=735d8ea7&scoped=true&"
import script from "./indexCategoryItems(old).vue?vue&type=script&lang=js&"
export * from "./indexCategoryItems(old).vue?vue&type=script&lang=js&"
import style0 from "./indexCategoryItems(old).vue?vue&type=style&index=0&id=735d8ea7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735d8ea7",
  null
  
)

export default component.exports